import {Loader} from 'organization/theme/Loader'
import React from 'react'

export function FullPageLoader() {
  return (
    <div id="preloader">
      <Loader />
    </div>
  )
}
